// extracted by mini-css-extract-plugin
export var footer = "index-module--footer--ba88f";
export var footerInner = "index-module--footerInner--ee7ff";